import React from 'react';
import classNames from 'classnames';
import css from './FreeTrialWarning.module.css';
import { Button } from '@mm/components';
import { useFreeTrialUpgradeModal } from '../../../../common/modals/FreeTrialUpgradeModal/use-free-trial-upgrade-modal';
import { useViewActions } from '@mm/state/actions/viewActions';
import { landmineNames } from '@mm/constants/landmine-names';

interface IFreeTrialWarning {
  className?: string;
  isVisible: boolean;
  onUpgradeClick?: (
    e?: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => void;
}

export const useFreeTrialWarningProps = (): IFreeTrialWarning => {
  const modal = useFreeTrialUpgradeModal();
  const viewActions = useViewActions();
  return {
    onUpgradeClick: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      viewActions.hideSlideoutMenu();
      modal.openFreeTrialUpgradeModal(
        {
          landmineName: landmineNames.FREE_TRIAL_WARNING,
        },
        e,
      );
    },
    isVisible:
      modal.isFreeTrial && modal.currentSubscription?.state !== 'future',
  };
};

export const FreeTrialWarningView = ({
  className,
  onUpgradeClick,
  isVisible,
}: IFreeTrialWarning) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div className={classNames(className, css.container)}>
      Messages sent from Free Trial accounts have "Sent from my Customers.ai"
      branding.{' '}
      <Button color="link" onClick={e => onUpgradeClick?.(e)}>
        Upgrade now to remove
      </Button>
    </div>
  );
};

export const FreeTrialWarning = (props: any) => {
  const freeTrialWarningProps = useFreeTrialWarningProps();
  return <FreeTrialWarningView {...freeTrialWarningProps} {...props} />;
};
